import * as React from 'react';
import { isValid } from 'date-fns';
import DatePicker from 'react-datepicker';
import DatePickerWrapper, { Input } from './DatePickerWrapper';
const CustomDateTimePicker = ({ disabled = false, showYearDropdown = true, value = null, onChange, timeIntervals = 5, dateFormat = 'dd.MM.yyyy HH:mm', isClearable = true, ...other }) => {
    const handleChangeRaw = (e) => {
        if (e && isValid(e.target.value)) {
            onChange(new Date(e.target.value));
        }
    };
    return (React.createElement(DatePickerWrapper, null,
        React.createElement(DatePicker, { dateFormat: dateFormat, timeFormat: "HH:mm", placeholderText: "dd.MM.yyyy hh:mm", timeIntervals: timeIntervals, showTimeSelect: true, selected: value, onChange: onChange, onChangeRaw: handleChangeRaw, disabled: disabled, isClearable: !disabled && isClearable, showYearDropdown: showYearDropdown, customInput: React.createElement(Input, { ...other }), timeCaption: "\u010Cas", ...other })));
};
export default CustomDateTimePicker;
